<template>
  <div class="home_warp">
    <!-- 路由含fromM则是在初中的iframe中，避免多重嵌套-->
    <iframe id="myIframe"
            v-if="!$route.query.fromM"
            :src="middleUrl+'/login?fromH=1'"
            width="500px"
            style="display:none" />

    <div class="login_warp">
      <div class="fixed_wrap">
        <img src="@/assets/leftcontroller/返回.png"
             @click="back"
             class="fixed_back_btn"
             alt="">
      </div>
      <div class="title">
        天天进步智能备考系统

      </div>
      <div class="level">
        <span style="color:#999;cursor:pointer"
              class="level_normal"
              @click="toMiddle">初中</span>
        <span style="color:#2196f3"
              class="level_active">高中</span>
      </div>
      <!-- <div class="base_title">首次登录请完善资料</div> -->

      <div class="form">
        <el-row>
          <el-input class="input_class"
                    v-model="form.phone"
                    placeholder="请输入手机号">
            <img slot="prefix"
                 class="icons"
                 src="../../assets/login/账号.png"
                 alt="">
          </el-input>
        </el-row>
       
        <el-row>
          <el-input class="input_class"
                    v-model="form.code"
                    placeholder="请输入短信验证码">
            <img slot="prefix"
                 class="icons"
                 src="../../assets/login/ShieldCheck.png"
                 alt="">
            <template #suffix>
              <van-button size="small"
                          class="btns_sms"
                          style=""
                          @click="sendSms"
                          native-type="button"
                          v-show="num==0"> 发送验证码</van-button>
              <span v-show="num>0"
                    style="color:#ccc;line-height:56rem">
                {{num}}s后重新获取
              </span>
            </template>

          </el-input>

        </el-row>
        <el-row>
          <el-select v-model="form.liantong_id"
                     class="input_class"
                     clearable
                     @change="changeCardType"
                     placeholder="请选择开通的商品类别">
            <el-option v-for="item in productList"
                       :key="item.id"
                       :label="item.card_type=='sl-h-all'?'全科'+item.id:'单科'+item.id"
                       :value="item.id">
                       <span style="float: left">{{ item.card_type=='sl-h-all'?"全科"+item.id:"单科" +item.id }}</span>
                 
            </el-option>
            <template slot="prefix">
              <img class="icons"
                   src="../../assets/login/shop.png"
                   alt="">
            </template>
          </el-select>
        </el-row>

        <!-- <el-row>
          <el-select class="input_class"
                     v-model="form.user_class_id"
                     style="width: 100%;"
                     placeholder="请选择版本">
            <el-option v-for="item in versionList"
                       :key="item.user_class_id"
                       :label="item.user_class_name"
                       :value="item.user_class_id">
            </el-option>
            <template slot="prefix">
              <img class="icons"
                   src="../../assets/login/版本.png"
                   alt="">
            </template>
          </el-select>
        </el-row> -->
        
        <el-row v-if="has_user=='0'">
          <el-input class="input_class"
                    type="password"
                    v-model="form.password"
                    placeholder="请输入密码">
            <img slot="prefix"
                 class="icons"
                 src="../../assets/login/密码.png"
                 alt="">
          </el-input>
        </el-row>
        <el-row v-if="has_user=='0'">
            <el-input class="input_class"
                      type="password"
                      v-model="form.passwordCheck"
                      @blur="checkPassword2"
                      placeholder="请再次输入密码">
                      <img slot="prefix"
                 class="icons"
                 src="../../assets/login/密码.png"
                 alt="">
            </el-input>
          </el-row>
          <el-row v-if="has_user=='0'">
          <el-input class="input_class"
                    v-model="form.truename"
                    clearable
                    placeholder="请输入学生姓名">

          </el-input>

        </el-row>
        <el-row>
          <el-select v-model="form.edu_grade_id"
                     class="input_class"
                     clearable
                     placeholder="请选择年级">
            <el-option v-for="item in gradeList"
                       :key="item.grade_id"
                       :label="item.grade_name"
                       :value="item.grade_id">
            </el-option>
          </el-select>
        </el-row>

        <el-row>
          <el-select v-model="form.province_id"
                     class="input_class"
                     @change="gradeChange"
                     clearable
                     placeholder="请选择地区">
            <el-option v-for="item in placeList"
                       :key="item.paper_district_id"
                       :label="item.paper_district_name"
                       :value="item.paper_district_id">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <el-select v-model="form.subject_ids"
                     class="input_class"
                     multiple
                     clearable
                     :multiple-limit="cardType=='sl-h-all'?null:1"
                     placeholder="请选择科目(选择已开通科目，使用时长可累计)">
            <el-option v-for="item in subjectList"
                       :key="item.subject_id"
                       :label="item.subject_name + (subject_ids.includes(item.subject_id) ? '(已开通)' : '')"
                       :value="item.subject_id"
                       :disabled="isSubjectDisabled(item.subject_id)">
            </el-option>

          </el-select>
        </el-row>
        <div class="check_warp"
             style="margin-top:20rem">
          <div>
            <el-checkbox v-model="opertionForm.consent">同意</el-checkbox>
            <span class="protocol"
                  @click="showProtocol">《用户协议》
            </span>
          </div>
        </div>

      </div>

      <div class="btn_warp">
        <div class="btn"
             @click="toHome()">
          确定
        </div>
        <div class="btn_group">
          <div class="text"
               @click="toLoginPage">
            学习卡登录
          </div>
        </div>
      
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               top="1vh"
               width="1050rem"
               :before-close="handleClose">
      <protocol />
      <div class="btn_warp">
        <el-button @click="handleClose"
                   type="primary">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import middleUrl from '@/utils/middleUrl.js'
import protocol from '@/views/personalCenter/components/protocol'
import CryptoJS from 'crypto-js';
import { Toast } from 'vant';
import { getverify, toActivate, invitecodeVerify, getGrade, getPalceList, verifyUser, getSelectSubject ,hasLianTong} from '@/api/activate.js'
import { getverifyM, toActivateM, getGradeM } from '@/api/activateMiddle.js'
import { register } from '../../api/activate';
export default {
  data () {
    return {
      middleUrl,
      form: {
        // mobile: '15552298893',
        // password: '298893',
        mobile: '',
        password: '',
        code: '',
        invite_code: '',
        passwordCheck: '',
        edu_grade_id: '',
        province_id: '',
        truename: '',
        type: 'register2',
        app_id: '1',
        app_key: 'daydayup',
        app_version: '1.7.9',
        pad_type: 'web', subject_ids: []
      },
      checked: false,
      opertionForm: {
        rememberPassword: false,
        autoLogin: '',
        consent: true
      },
      dialogVisible: false,
      isAuto: true,
      secretkey: 'acdb',
      num: 0,
      isShowLogin: false,
      gradeList: [],
      placeList: [],
      productList:[],
      versionList: [],
      subjectList: [],
      subject_ids:[],
      isPass: false,
      isCheck: false,
      cardType:null,
      has_user:null,
      disabledSubjects: [4, 9, 10, 6, 5, 3]

    }
  },
  watch: {
    'form.subject_ids': {
      handler (newVal, oldVal) {
        const abledSubjects = [4, 9, 10, 6, 5, 3]; // 6选3

        const disabledCount = abledSubjects.filter(subject_id => newVal.includes(subject_id)).length;
        const flag = this.subjectList.length == 9 ? 6 : 7
        if (disabledCount >= 3 && flag == this.form.subject_ids.length&&this.form.edu_grade_id!=3) {
          this.$message.info("除了语数（文理）英 ，剩下6科只能选三科！");
        }
      },
      deep: true // 如果 form.subject_ids 是一个数组或对象，需要设置为 true 才能深度监视其变化
    }
  },
  components: { protocol },
  mounted () {
    if (this.$route.query.invite_code) {
      this.form.invite_code = this.$route.query.invite_code
      window.localStorage.setItem('invite_code', this.$route.query.invite_code)
    } else {
      if (window.localStorage.getItem('invite_code')) {
        this.form.invite_code = window.localStorage.getItem('invite_code')
      }
    }

    console.log('this.$route.query.fromM', this.$route.query);
    // this.liantongData = JSON.parse(window.localStorage.getItem('liantong'))
  
    if (this.$route.query) {
      this.form = {
        ...this.form,
        ...this.$route.query
      };
    }
    if (!this.$route.query.fromM) {
      this.$http({
        url: '/api/v1/app/class_list',
        method: 'get',
      }).then(res => {
        this.versionList = res.data
      })
    }
    this.getGradeList()
    this.getPlace()

  },
  methods: {
   
    isSubjectDisabled(subjectId) {
      console.log('sssssss',this.form.grade_id);
      
      if(this.form.edu_grade_id == 3){
return false;
      }
  const formSubjects = this.form.subject_ids; // 当前已选择的科目
  const group1 = [4, 6]; // 4 和 6 中只能选择一个
  const group2 = [9, 10, 5, 3]; // 至少选择两个
  const group3 = [7, 11, 12]; // 必须全部选择

  // 检查组1：4 和 6 中只能选择一个
  if (group1.includes(subjectId)) {
    const selectedInGroup1 = group1.filter(id => formSubjects.includes(id));
    return selectedInGroup1.length > 0 && selectedInGroup1[0] !== subjectId;
  }

  // 检查组2：9, 10, 5, 3 中至少选择两个
  if (group2.includes(subjectId)) {
    const selectedInGroup2 = group2.filter(id => formSubjects.includes(id));
    return selectedInGroup2.length >= 2;
  }

  // 检查组3：7, 11, 12 必须全部选择
  if (group3.includes(subjectId)) {
    const selectedInGroup3 = group3.filter(id => formSubjects.includes(id));
    return selectedInGroup3.length > 3;
  }

  // 其他情况默认不禁用
  return false;
}, 
    gradeChange () {
      this.form.subject_ids = []
      this.getSelectSubjectList()
    },
    back () {
      if (this.isShowLogin) {
        this.isShowLogin = false
      } else {
        this.$router.go(-1)

      }
    },
    checkPassword () {
      if (this.form.password.length < 6) {
        this.isCheck = false
        this.$message.error('密码长度不能少于6位')
      } else {
        this.isCheck = true
      }

    },
    checkPassword2 () {
      if (this.form.passwordCheck.length < 6) {
        this.$message.error('密码长度不能少于6位')
        return
      }
      if (this.form.password != this.form.passwordCheck) {
        this.isPass = false
        this.$message.error('两次密码输入不一致')
      } else {
        this.isPass = true
      }
    },
    async getPlace () {
      const { data } = await getPalceList()
      this.placeList = data.list
    },
    async getSelectSubjectList () {
      const { data } = await getSelectSubject({
        edu_grade_id: this.form.edu_grade_id,
        paper_district_id: this.form.province_id
      })
      this.subjectList = data.subject_list
    },
    async getGradeList () {
      // if (this.level == 1) {
      const { data } = await getGrade()
      this.gradeList = data.list
      // } else if (this.level == 2) {
      //   const { data } = await getGradeM()
      //   this.gradeList = data.list
      // }
    },
    changeCardType(val){
      const selectedItem = this.productList.find(item => item.id == val);
  if (selectedItem) {
    this.cardType = selectedItem.card_type;
  }
    },
    getMData () {
      var aData = localStorage.getItem("aPageData");
      if (aData) {
        this.setMData(aData);     // 当能获取到数据时就说明是从高中页面跳转过来的
        localStorage.removeItem("aPageData");
      } else if (this.$route.query.fromM) {
        // 在初中iframe中监听
        window.addEventListener("message", receiveMessage, false);
      } else {
        // console.log('chuzhong')
        this.initData()
      }
      function receiveMessage (event) {
        if (event.origin !== middleUrl && event.origin + '/#' !== middleUrl) return;
        if (event.data) {
          localStorage.setItem("aPageData", event.data);
        }
      }
    },
    toActivate () {
      // this.$router.push('/activate')
      let routeUrl = this.$router.resolve({
        path: "/activate"
      });
      window.open(routeUrl.href, '_blank');
    },
    toLoginPage(){
   this.$router.push('/loginUnicom')
    },
    setMData (data) {
      let postData = JSON.parse(data)
      this.form.mobile = postData.form.account
      this.form.password = postData.form.password
      this.opertionForm.rememberPassword = postData.opertionForm.rememberPassword
      this.opertionForm.autoLogin = postData.opertionForm.autoLogin
    },

    initData () {
      if (window.localStorage.getItem("userInfo") && this.isAuto) {
        this.$router.push('/index')
        return
      }
      let form = window.localStorage.getItem('loginForm')
      let opertionForm = window.localStorage.getItem('opertionForm')

      if (JSON.parse(opertionForm)) {
        this.opertionForm = JSON.parse(opertionForm)
      }
      if (this.opertionForm.rememberPassword) {
        if (form) {
          form = JSON.parse(form)
          if (form.password.length > 10) {
            form.password = CryptoJS.AES.decrypt(form.password, this.secretkey).toString(CryptoJS.enc.Utf8)
          }
          this.$set(this, 'form', form)

        }
      }
      if (this.opertionForm.autoLogin && !this.$route.query.not_auto_login) {
        this.toHome()
      } else {
        window.localStorage.removeItem('opertionForm')
      }
    },
    toLogin () {
      // this.form.phone = this.form.mobile
 
      this.$http({
        url: '/api/v1/login',
        method: 'POST',
        data: this.form
      }).then(res => {
        window.localStorage.setItem('userInfo', JSON.stringify(res.data))
        // if (res.data.edu_school_id == 1) {
        //   if (this.opertionForm.rememberPassword || this.opertionForm.autoLogin) {
        let form = JSON.parse(JSON.stringify(this.form))
        // 简单加密
        form.password = CryptoJS.AES.encrypt(this.form.password, this.secretkey).toString()
        window.localStorage.setItem('loginForm', JSON.stringify(form))
        // }
        window.localStorage.setItem('opertionForm', JSON.stringify(this.opertionForm))
        // }
        this.$message.success('登录成功')
        this.$router.push('/home')
      })

    },

    async toHome () {

      // if (this.isShowLogin) {

      // if (this.form.truename == '') {
      //   this.$message.warning('请输入学生姓名');
      //   return
      // }
      // if (this.form.edu_grade_id == '') {
      //   this.$message.warning('请选择年级');
      //   return
      // }
      // if (this.form.paper_district_id == '') {
      //   this.$message.warning('请选择地区');
      //   return
      // }

      // let info = JSON.parse(window.localStorage.getItem('liantong'))


      // console.log('id', info['id'], info);
      // this.form.liantong_id = info['id']
      this.$http({
        url: '/api/v1/stucard/liantong_register',
        method: 'POST',
        data: this.form
      }).then(res => {

        this.$message.success('完善资料成功')
        if(this.has_user=='0'){
          this.toLogin()
        }else{
          this.$router.push('/loginUnicom')
        }
        
        // this.$router.push('/home')
      })



    },

    autoLogin () {
      if (this.opertionForm.autoLogin) {
        this.opertionForm.rememberPassword = true
      }
    },
    rememberPassword () {
      if (this.opertionForm.autoLogin && !this.opertionForm.rememberPassword) {
        this.opertionForm.autoLogin = false
      }
    },
    toMiddle () {
      // 利用postMessage，iframe,localStroage传递高中输入的数据到初中页面
      let myIframe = document.getElementById("myIframe");
      if (myIframe) {
        let data = { form: this.form, opertionForm: this.opertionForm }
        myIframe.contentWindow.postMessage(JSON.stringify(data), middleUrl + '/loginRegister?fromH=1')
        window.open(middleUrl+'/loginRegister', "_self")

      } else {
        // window.location.href = middleUrl
        return
      }
    },
    async sendSms () {
      if (!this.form.phone) {
        this.$message.error('请输入手机号');
        return
      }
   
      this.$http({
        url: '/api/v1/stucard/liantong_data',
        method: 'post',
        data:{ phone: this.form.phone}
      }).then(res => {
        this.productList = res.data
      })
      const {data:res} = await hasLianTong({
    phone: this.form.phone,
      });
      if(res.has_liantong!==""){
        window.localStorage.setItem('liantong',res.has_liantong);
      }else{
        this.$message.error('您未有符合条件的订单，请核对后再进行学习卡激活！');
        return;
      }
      this.subject_ids = res.subject_ids
      this.has_user = res.has_user
      const liantongData = window.localStorage.getItem('liantong')
    
      if (liantongData!=""&&liantongData!="undefined") {
    this.cardType = JSON.parse(liantongData).card_type
  }
  console.log('this',this.cardType)
 
      try {
        console.log('sssssssssss', this.form.phone)
        if (this.form.phone) {
          await getverify({
            mobile: this.form.phone,
            type: 'register2',
            is_liantong:1
          })
          Toast({
            message: '发送成功',
            position: 'top',
            className: 'toast_class'
          });
          this.num = 59
          this.intervalId = setInterval(() => {
            this.num -= 1;
            if (this.num == 0) {
              clearInterval(this.intervalId)
            }
          }, 1000);
        } else if (this.form.grade_id == 2) {
          // 初中
          await getverifyM({
            mobile: this.form.phone,
            type: register2
          })
          Toast({
            message: '发送成功',
            position: 'top',
            className: 'toast_class'
          });
          this.num = 59
          this.intervalId = setInterval(() => {
            this.num -= 1;
            if (this.num == 0) {
              clearInterval(this.intervalId)
            }
          }, 1000);
        }

      } catch (err) {
        // Toast({
        //   message: err.msg,
        //   position: 'top',
        // });
      }
    },
    handleClose () {
      this.dialogVisible = false
    },
    showProtocol () {
      this.dialogVisible = true
    }

  },
  beforeRouteEnter (to, from, next) {
    // 若是从’/index‘，跳转到’/login‘，则不默认直接跳转’/index'
    if (from.path == '/index') {
      next(vm => {
        vm.isAuto = false
      })
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.home_warp {
  width: 100vw;
  // height: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  background-image: url("../../assets/login/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .fixed_wrap {
    position: absolute;
    left: 24rem;
    top: 24rem;

    .fixed_back_btn {
      cursor: pointer;
      top: 15rem;
      left: 25rem;
      width: 50rem;
    }
  }
  .login_warp {
    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 256rem;
      height: 176rem;
      top: -152rem;
      left: 50%;
      margin-left: -125rem;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    flex: 1;
    // margin-top: 25vh;
    // margin-left: 32%;
    // margin-right: 32%;
    // margin-top: 71rem;
    position: relative;
    margin-top: 179rem;
    margin-left: 560rem;
    margin-right: 560rem;
    height: fit-content;
    // padding-bottom: 84rem;
    padding-bottom: 60rem;
    text-align: center;
    // background-image: url("../../assets/login/白板.png");
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    background: #ffffff;
    box-shadow: 0px 2rem 14rem 0px rgba(141, 184, 227, 0.32);
    border-radius: 20rem;
    border: 20rem solid #dcedfc;
    text-align: center;
    .title {
      font-size: 40rem;
      font-weight: 800;
      margin-top: 52rem;
      color: #2196f3;
      text-align: center;
      line-height: 1.6;
    }
    .base_title {
      color: var(--neutral-color-111111, #111);
      margin: 0 128rem;
      font-family: "PingFang SC";
      font-size: 24rem;
      font-style: normal;
      font-weight: 600;
      text-align: left;
      line-height: 36rem; /* 150% */
    }
  }
}
::v-deep .van-button--small {
  height: 56rem;
  padding: 0 8rem;
  font-size: 16rem;
}
::v-deep .el-input--medium .el-input__inner {
  height: 40rem;
  line-height: 40rem;
  font-size: 16rem;
}
.icons {
  width: 20rem;
  height: 20rem;
}
.form {
  width: 520rem;
  margin: 0 128rem;
}
.btns_sms {
  background: transparent;
  border: 0;
  color: #2196f3;
}
.check_warp {
  display: flex;
  margin-top: 24rem;
  div {
    flex: 1;
    color: #666666;
    &:nth-child(1) {
      text-align: left;
    }
    &:nth-child(2) {
      text-align: right;
    }
  }
}
.btn_warp {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 28rem;
  flex-direction: column;
  align-items: center;
  .btn_group {
    // width: 196rem;
    margin-top: 16rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    .text:hover {
      color: #2196f3;
      cursor: pointer;
    }
  }
  .btn {
    width: 360rem;
    height: 48rem;
    line-height: 48rem;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    text-align: center;
    font-size: 18rem;
    color: white;
    border-radius: 44rem;
    background: #fb9930;
    font-weight: bold;
    // letter-spacing: 10rem;
    cursor: pointer;
  }
  .btn_text {
    margin-top: 20rem;
    line-height: 24rem;
    cursor: pointer;
    font-size: 18rem;
    color: #fb9930;
    text-decoration: underline;
    &:hover {
      color: #2196f3;
    }
  }
  .text {
    color: var(--light-666666, var(--neutral-color-666666, #666));
    text-align: center;
    font-family: "PingFang SC";
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem; /* 150% */
    // width: 80rem;
  }
}
::v-deep .el-input__prefix {
  left: 12rem;
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 41rem !important;
  font-size: 18rem !important;
}
::v-deep .el-input--medium .el-input__inner {
  height: 56rem !important;
  line-height: 56rem !important;
}
.el-input__prefix {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    padding-left: 1rem;
    width: 24rem;
    height: 24rem;
  }
}
::v-deep .el-input {
  margin-top: 16rem;
  font-size: 18rem;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-input__inner::placeholder {
  font-size: 18rem;
}
::v-deep .el-checkbox__label {
  font-size: 18rem;
  padding-left: 8px;
}
::v-deep .el-checkbox__inner {
  width: 20rem;
  height: 20rem;
  border-radius: 4rem;
}
::v-deep .el-checkbox__input {
  line-height: 1.5;
}

::v-deep .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 2rem solid #fff;
  border-left: 0;
  border-top: 0;
  width: 5rem;
  height: 11rem;
  left: 6rem;
  position: absolute;
  top: 1rem;
  transform: rotate(38deg) scaleY(0);
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}

::v-deep .el-input__prefix {
  display: flex;
  align-items: center;
}
.level {
  margin-top: 20rem;
  font-size: 18rem;
  width: 360rem;
  margin: 20rem auto 0;
  display: flex;
  justify-content: space-around;
  line-height: 1.5;
  span {
    position: relative;
    padding-left: 25rem;
  }
  span:before {
    width: 18rem;
    height: 18rem;
    box-sizing: border-box;
    content: "";
    // border: 3rem solid #2196f3;
    display: inline-block;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    margin-top: -9rem;
    left: 0;
  }
  span.level_active:before {
    border: 3rem solid #2196f3;
  }
  span.level_normal:before {
    border: 1rem solid #ccc;
  }
}
.protocol {
  color: #3f9eff;
  font-size: 18rem;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
::v-deep .el-dialog__body {
  padding: 0px 20px 30px;
}
::v-deep .el-dialog__header {
  padding: 0px 20px 10px;
}
::v-deep .el-dialog__headerbtn {
  padding: 2px 3px 1px;
  border-radius: 50%;
  border: 1px solid #bbb;
}
</style>
